<template>
  <vue-apex-charts
    ref="chart"
    type="line"
    height="400"
    :options="chartOptions"
    :series="internalSeries"
  />
</template>
<script setup>
import VueApexCharts from 'vue-apexcharts'
import { ref, onMounted, computed, watch, toRefs, onBeforeUnmount } from 'vue'

const internalSeries = ref([])
const chart = ref(null)
const props = defineProps({
  color1: {
    type: String,
    default: '#FF1654',
  },
  color2: {
    type: String,
    default: '#247BA0',
  },
  title1: {
    type: String,
    default: 'Series A',
  },
  title2: {
    type: String,
    default: 'Series B',
  },
  categories: {
    type: Array,
    default() {
      return ['Set 1', 'Set 2', 'Set 3', 'Set 4', 'Set 5', 'Set 6']
    },
  },
  series: {
    type: Array,
    default() {
      return [{
        name: 'Series A',
        data: [1.4, 2, 2.5, 1.5, 2.5, 2.8, 3.8, 4.6],
      },
      {
        name: 'Series B',
        data: [20, 29, 37, 36, 44, 45, 50, 58],
      }]
    },
  },
  xTickAmount: {
    type: Number,
    default: 6,
  },
  yTickAmount1: {
    type: Number,
    default: 5,
  },
  yTickAmount2: {
    type: Number,
    default: 5,
  },
})
const { color1, color2, title1, title2, series, categories, xTickAmount, yTickAmount1, yTickAmount2 } = toRefs(props)

const chartOptions = ref({
  chart: {
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
  },
  grid: {
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  tooltip: {
    custom(item) {
      return `${'<div class="px-1 py-50"><span>'}${
        item.series[item.seriesIndex][item.dataPointIndex]
      }</span></div>`
    },
  },
  colors: [color1.value, color2.value],
  xaxis: {
    categories: categories.value,
    tickAmount: xTickAmount.value,
  },
  yaxis: [
    {
      tickAmount: yTickAmount1.value,
      labels: {
        style: {
          colors: color1.value,
        },
      },
      title: {
        text: title1.value,
        style: {
          color: color1.value,
        },
      },
    },
    {
      tickAmount: yTickAmount2.value,
      opposite: true,
      labels: {
        style: {
          colors: color2.value,
        },
      },
      title: {
        text: title2.value,
        style: {
          color: color2.value,
        },
      },
    },
  ],
})
function refresh() {
  // console.log('render', chart.value)
  if (chart.value) {
    chart.value.refresh()
  }
}
internalSeries.value = [...series.value]
watch(series, newData => {
  console.log('update series', newData)
  internalSeries.value = [...newData]
  refresh()
})

defineExpose({ refresh })
</script>
<style>
</style>
